import * as Yup from 'yup';

export const getProductShape = () => ({
  description: Yup.string().required('Informe a justificativa'),
});
